import { useCallback } from 'react';
import {
    openProjectModal as openProjectModalBase,
    closeProjectModal as closeProjectModalBase,
    toggleProjectCabinet as toggleProjectCabinetBase,
    saveProject as saveProjectBase,
    handleDeleteProject as handleDeleteProjectBase,
    openProjectDetail as openProjectDetailBase,
    closeProjectDetail as closeProjectDetailBase
} from '../../services/projects';

export function useProjectsController({
    projectForm,
    projectEditId,
    request,
    setBusy,
    setStatus,
    showStatus,
    loadWorkspaces,
    savedProjectFilter,
    setSavedProjectFilter,
    openProjectCard,
    closeProjectCard,
    setTaskFilters,
    taskFilters,
    setProjectEditId,
    setProjectForm,
    setProjectModalOpen
}) {
    const openProjectModal = useCallback((workspace = null) =>
        openProjectModalBase({
            workspace,
            setProjectEditId,
            setProjectForm,
            setProjectModalOpen
        }), [setProjectEditId, setProjectForm, setProjectModalOpen]);

    const closeProjectModal = useCallback(() => closeProjectModalBase(setProjectModalOpen), [setProjectModalOpen]);

    const toggleProjectCabinet = useCallback((cabinetId) =>
        toggleProjectCabinetBase(cabinetId, setProjectForm), [setProjectForm]);

    const saveProject = useCallback((event) =>
        saveProjectBase({
            event,
            projectForm,
            projectEditId,
            request,
            setBusy,
            setStatus,
            showStatus,
            loadWorkspaces,
            closeProjectModal
        }), [
            projectForm,
            projectEditId,
            request,
            setBusy,
            setStatus,
            showStatus,
            loadWorkspaces,
            closeProjectModal
        ]);

    const handleDeleteProject = useCallback((workspaceId) =>
        handleDeleteProjectBase({
            workspaceId,
            request,
            setBusy,
            setStatus,
            showStatus,
            loadWorkspaces
        }), [request, setBusy, setStatus, showStatus, loadWorkspaces]);

    const openProjectDetail = useCallback((workspaceId) =>
        openProjectDetailBase({
            workspaceId,
            taskFilters,
            setSavedProjectFilter,
            openProjectCard,
            setTaskFilters
        }), [taskFilters, setSavedProjectFilter, openProjectCard, setTaskFilters]);

    const closeProjectDetail = useCallback(() =>
        closeProjectDetailBase({
            savedProjectFilter,
            closeProjectCard,
            setTaskFilters
        }), [savedProjectFilter, closeProjectCard, setTaskFilters]);

    return {
        openProjectModal,
        closeProjectModal,
        toggleProjectCabinet,
        saveProject,
        handleDeleteProject,
        openProjectDetail,
        closeProjectDetail
    };
}
